import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useDiwanHubAnalytics } from "./diwan-hub_analytics";
import { generalInfo, partnerConfig } from "./diwan-hub_partner_config";

const Theme = lazyWithRetry(() => import("./diwan-hub_theme"));

const faqs = [
  {
    question: "Tell me more about your conference rooms",
    answer:
      "Check in to a meeting room to really hone in on a challenge, available as and when it suits you.	",
  },
];

export function OfferingDiwanHubMeetingRoom() {
  useDiwanHubAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
